import {useCallback} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useLazyQuery, gql} from '@apollo/client'
import {
  setStateChartVariables as setStateChartVariablesAction,
  resetStateChartVariables as resetStateChartVariablesAction,
  selectStateChartVariables
} from '../slices/stateChartSlice'

const STATE_QUERY = gql`
  query sdohPopulation($SDOH_KEY: AlphabetOnly!, $STATE_ABBREVIATION: AlphabetOnly!) {
    sdohPopulation(SDOH_KEY: $SDOH_KEY, STATE_ABBREVIATION: $STATE_ABBREVIATION) {
      DATA_BRICK
      option_name
      option_count_per_100k
    }
  }
`

/**
 * Query hook for fetching state-level SDOH population chart data
 */
export function useQuerySdohStateChart(chartVariables) {
  const [getChartStateData, {data: chartData, loading: loadingChart, refetch: refetchChart, error: errorLoadingChart}] =
    useLazyQuery(STATE_QUERY, {
      context: {clientName: 'longitudinal'},
      variables: {
        SDOH_KEY: chartVariables?.sdohKey,
        STATE_ABBREVIATION: chartVariables?.stateCode
      },
      notifyOnNetworkStatusChange: true,
      errorPolicy: 'all'
    })
  return [getChartStateData, {chartData, loadingChart, refetchChart, errorLoadingChart}]
}

/**
 * Hook for managing state chart variables and queries
 * Replaces StateChartProvider
 */
export const useStateChartProvider = () => {
  const dispatch = useDispatch()
  const stateChartVariables = useSelector(selectStateChartVariables)

  const [getChartStateData, chartStateData] = useQuerySdohStateChart(stateChartVariables)

  const updateStateChartVariables = useCallback(
    (variables) => {
      dispatch(setStateChartVariablesAction(variables))
    },
    [dispatch]
  )

  const resetVariables = useCallback(() => {
    dispatch(resetStateChartVariablesAction())
  }, [dispatch])

  return {
    stateChartVariables,
    getChartStateData,
    chartStateData,
    setStateChartVariables: updateStateChartVariables,
    resetStateChartVariables: resetVariables
  }
}
